<template>
  <el-dialog
  :close-on-click-modal="false"
  :title="dialogFormVisibleTitle"
  :visible.sync="dialogFormVisible"
  width="30%">
  <el-form :model="ruleForm" :rules="rules" ref="ruleFormRef" label-width="140px" class="demo-ruleForm">
    <el-form-item label="粮食品种">
       {{rowData.grKindCn}}
    </el-form-item>
    <el-form-item label="质检模板类型">
       {{rowData.type}}
    </el-form-item>
    <el-form-item label="质检项">
       {{rowData.chItemCn}}
    </el-form-item>
    <el-form-item label="普通增扣量" v-if="includesWater">
        <el-input v-model="ruleForm.commonLimit" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g,'$1')" @blur="ruleForm.commonLimit = $event.target.value" @change="getwaterTotal"></el-input>
    </el-form-item>
    <el-form-item label="整晒增扣量" v-if="includesWater">
        <el-input v-model="ruleForm.specialLimit" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g,'$1')" @blur="ruleForm.specialLimit = $event.target.value" @change="getwaterTotal"></el-input>
    </el-form-item>
    <el-form-item label="增扣量比例(1/n)" prop="proportion">
        <el-input v-model="ruleForm.proportion" :disabled="includesWater" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g,'$1')" @blur="ruleForm.proportion = $event.target.value"></el-input>
    </el-form-item>
    <el-form-item label="标准值" prop="limitTotal">
        <el-input v-if="rowData.chItemCn.indexOf('水分')!=-1" v-model="ruleForm.limitTotal" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g,'$1')" @blur="ruleForm.limitTotal = $event.target.value"></el-input>
        <el-input v-else v-model="ruleForm.limitTotal"></el-input>
    </el-form-item>
    <el-form-item label="步长" prop="stepLength">
        <el-input v-model="ruleForm.stepLength" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,4})?).*$/g,'$1')" @blur="ruleForm.stepLength = $event.target.value"></el-input>
    </el-form-item>
  </el-form>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogFormVisible = false">取 消</el-button>
    <el-button type="primary" @click="submitForm('ruleFormRef')">确 定</el-button>
  </span>
</el-dialog>
</template>
<script>
import {httpToken} from '@/utils/http'
import {getNumber,objdata_set} from '@/utils/util'
export default {
  data() {
    return {
        dialogFormVisibleTitle:'',//弹框标题
        dialogFormVisible:false,//弹框显示
        includesWater:false,//是否包含水分
        rowData:'',//传入的单项数据
        ruleForm:{
            commonLimit:'',//普通增扣量
            specialLimit:'',//整晒增扣量
            limitTotal:0,//标准值
            stepLength:0,//步长
            proportion:0,//增扣量比例
        },//表单数据
        rules: {
          limitTotal: [
            { required: true, message: '请输入标准值', trigger: 'blur' },
          ],
          stepLength: [
            { required: true, message: '请输入步长', trigger: 'blur' },
          ],
          proportion: [
            { required: true, message: '请输入增扣量比例', trigger: 'blur' },
          ],
        },//表单校验
    }
  },
  methods: {
    // 获取水分标准值
    getwaterTotal(){
        this.ruleForm.proportion=getNumber(this.ruleForm.commonLimit)+getNumber(this.ruleForm.specialLimit)
    },
    // 弹框展示
    showDialog(row){
        this.rowData=row
        if(row.chItemCn.indexOf('水分')!==-1){
            this.includesWater=true
        }else{
            this.includesWater=false
        }
        this.dialogFormVisibleTitle='设置'
        this.dialogFormVisible=true
        let that=this
        this.$nextTick(()=>{
          that.$refs.ruleFormRef.resetFields()//对整个表单进行重置，将所有字段值重置为初始值并移除校验结果
          that.ruleForm.commonLimit=''
          that.ruleForm.specialLimit=''
          if(row.checkMouldDetailCompute){
            objdata_set(that.ruleForm,row.checkMouldDetailCompute)
          }
        })
    },
    // 表单提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
        // 没有添加过对应增扣量设置 走add 否则走update
          let data={...this.ruleForm,chMoDeId:this.rowData.id}
          let url='/check-mould-detail-compute/add'
          if(this.rowData.checkMouldDetailCompute){
            url='/check-mould-detail-compute/update'
            data.id=this.rowData.checkMouldDetailCompute.id
          }
          httpToken({
            url: url,
            method: 'post',
            data: data
          }).then(res => {
            this.$emit('emit')
            this.dialogFormVisible=false
          })
        } else {
          return false;
        }
      });
    },
  }
}
</script>
<style scoped lang="scss">
</style>